export const FONT_SIZE_SCALES = {
    small: 0.875,
    medium: 1,
    large: 1.125,
};
export const DEFAULT_FONT_SIZE = "medium";
export const DEFAULT_FONT_SCALE = FONT_SIZE_SCALES[DEFAULT_FONT_SIZE];
export function isMedosFontSize(value) {
    return (typeof value === "string" &&
        Object.prototype.hasOwnProperty.call(FONT_SIZE_SCALES, value));
}
export function resolveFontScale(value) {
    if (value === undefined || value === null)
        return DEFAULT_FONT_SCALE;
    if (!isMedosFontSize(value)) {
        console.warn(`[Medos] Ignoring unknown fontSize "${String(value)}". ` +
            `Expected one of: ${Object.keys(FONT_SIZE_SCALES).join(", ")}.`);
        return DEFAULT_FONT_SCALE;
    }
    return FONT_SIZE_SCALES[value];
}
function multiply(value, scale) {
    return Number.parseFloat((value * scale).toPrecision(12));
}
export function scaleCssFontSize(value, scale) {
    if (scale === 1)
        return value;
    const match = /^(-?[\d.]+)(px|rem)(\s*!important)?$/i.exec(value.trim());
    if (!match)
        return value;
    const n = Number.parseFloat(match[1]);
    if (!Number.isFinite(n))
        return value;
    return `${multiply(n, scale)}${match[2]}${match[3] ?? ""}`;
}
export function scaleSxFontSize(value, scale) {
    if (scale === 1)
        return value;
    if (typeof value === "number") {
        return Number.isFinite(value) ? multiply(value, scale) : value;
    }
    return scaleCssFontSize(value, scale);
}
